export const getCourseUpdates = (state) => state.courseUpdates.courseUpdates;
export const getCourseHandouts = (state) => state.courseUpdates.courseHandouts;
export const getSavingStatuses = (state) => state.courseUpdates.savingStatuses;
export const getLoadingStatuses = (state) => state.courseUpdates.loadingStatuses;
